<template>
  <div class="welcome">
    <transition name="slide">
      <div class="banner-box" v-if="show">
        <div class="image-banner" v-if="bannerUrl">
          <img :src="bannerUrl" alt="" />
          <div class="message">
            歡迎<span class="nickname"
              >{{ nickname }}</span
            >
            <!-- 進入直播間 -->
          </div>
        </div>
        <div class="banner" v-else>
          歡迎<span class="nickname"
            >{{ nickname }}</span
          >
          <!-- 進入直播間 -->
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import VoiceRoomIM from '@/components/VoiceRoom/voiceRoomIM';
import { formatAwsUrl } from '@/components/VoiceRoom/util';

export default {
  name: 'Welcome',
  props: {},
  data() {
    return {
      show: false,
      nickname: '',
      // bannerUrl: 'https://resource.funplus.social/sys-feed/entBanner1.png'
      bannerUrl: '',
      messageList: []
    };
  },
  watch: {
    async newJoinMember(nVal) {
      if (nVal && nVal.nickname) {
        await VoiceRoomIM.getMemberProfile(nVal.userUuid);
        const bannerObj = VoiceRoomIM.getMemberDressUp(nVal.userUuid);
        let bannerUrl = '';
        if (bannerObj) {
          const { ENTRANCE_BANNER } = bannerObj;
          bannerUrl =
            ENTRANCE_BANNER && ENTRANCE_BANNER.url
              ? formatAwsUrl(ENTRANCE_BANNER.url)
              : '';
        }
        this.messageList.push({
          nickname: nVal.nickname,
          bannerUrl: bannerUrl
        });
        this.showBanner();
      }
    }
  },
  computed: {
    // 加入的新用戶
    newJoinMember() {
      return VoiceRoomIM.newJoinMember;
    }
  },
  methods: {
    loadBanner(bannerUrl) {
      return new Promise((resolve) => {
        const image = new Image();
        image.src = bannerUrl;
        image.onload = () => {
          resolve(true);
        };
        image.onerror = () => {
          resolve(false);
        };
      });
    },
    async showBanner() {
      if (this.show) {
        return;
      }
      if (this.messageList[0] && this.messageList[0].bannerUrl) {
        await this.loadBanner(this.messageList[0].bannerUrl);
      }
      if (this.messageList.length) {
        this.nickname = this.messageList[0].nickname;
        this.bannerUrl = this.messageList[0].bannerUrl;
        this.show = true;
        setTimeout(() => {
          this.messageList.shift();
          this.show = false;
          if (this.messageList.length) {
            this.showBanner();
          }
        }, 2000);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.welcome {
  position: absolute;
  top: 60%;
  right: 0;
  font-size: 14px;
  text-align: center;
}
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s;
}
.slide-enter,
.slide-leave-to {
  transform: translateX(100%);
}
.banner-box {
  width: 200px;
  display: flex;
  align-content: center;
}
.image-banner,
.banner {
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.image-banner {
  position: relative;
  img,
  .message {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    color: white;
    width: 100%;
  }
  img {
    height: auto;
    z-index: 1;
  }
  .message {
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
  }
}
.banner {
  background: rgba(225, 225, 225, 0.5);
  padding: 10px 10px;
  color: #fff;
  z-index: 2;
  border-radius: 30px;
}
.nickname {
  display: inline-block;
  max-width: 120px;
  @include ellipsis;
  color: rgb(31, 31, 192);
}
</style>
